import { Box, Divider, Skeleton } from "@mui/material";
import Card from "../../mui/Card";
import { BORDER_RADIUS } from "@/constants/layout";

export default function ListSkeletonLoader() {
  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        padding: 2,
        gap: 2,
      }}
    >
      <Card
        sx={{
          borderRadius: BORDER_RADIUS.XL,
          overflow: "hidden",
          height: "375px",
          width: "100%",
          maxWidth: "240px",
        }}
        loading
        skeletonHeight={200}
      />
      <Card
        sx={{
          display: "flex",
          overflow: "hidden",
          maxWidth: "2200px",
          height: "100%",
          width: "100%",
          gap: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            width: "100%",
          }}
        >
          {Array.from({ length: 25 }, () => (
            <Box sx={{ height: "60px", width: "100%" }}>
              <Box sx={{ display: "flex", alignItems: "center", padding: 2, mt: -1 }}>
                <Skeleton height="35px" width="22px" animation="wave" />
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-around",
                    height: "100%",
                    width: "100%",
                    gap: 2,
                    ml: 2,
                  }}
                >
                  {Array.from({ length: 5 }, () => (
                    <Skeleton height="20px" width="100%" animation="wave" />
                  ))}
                </Box>
              </Box>
              <Divider sx={{ mt: -1 }} />
            </Box>
          ))}
        </Box>
      </Card>
    </Box>
  );
}
